import firebase from 'firebase';

export default {
  namespaced: true,
  state: {
    requests: []
  },
  getters: {

  },
  mutations: {
    setRequests(state, payload) {
      state.requests = payload
    },
    updateRead(state, payload) {
      const a = state.requests.findIndex(r => r.id === payload.id)
      const b = state.requests[a]
      b.been_read = payload.flag
      state.requests.splice(a, 1, b)
    },
    delRequest(state, payload) {
      state.requests = state.requests.filter(item => item.id !== payload);
    }
  },
  actions: {
    async addRequest({dispatch, commit}, {name, number, mail, problem, been_read}) {
      try {
        await firebase.database().ref('database/requests').push({
          name: name,
          number: number,
          mail: mail,
          problem: problem,
          been_read: been_read
        })
      } catch (e) {
        throw e
      }
    },
    async fetchRequests({commit}) {
      try {
        const requests = (await firebase.database().ref(`/database/requests`).once('value')).val() || {}
        const requests_arr =  Object.keys(requests).map(key => ({...requests[key], id: key}))
        commit('setRequests', requests_arr.reverse())
      } catch (e) {
        throw e
      }
    },
    async readRequest({commit}, id) {
      try {
        await firebase.database().ref(`/database/requests`).child(id).update({been_read: true})
        commit('updateRead', {id, flag: true})
      } catch (e) {
        throw e
      }
    },
    async unreadRequest({commit}, id) {
      try {
        await firebase.database().ref(`/database/requests`).child(id).update({been_read: false})
        commit('updateRead', {id, flag: false})
      } catch (e) {
        throw e
      }
    },
    async deleteRequest({commit}, id) {
      try {
        await firebase.database().ref(`/database/requests/${id}`).remove()
        commit('delRequest', id)
      } catch (e) {
        throw e
      }
    }
  }
}